import { Serializable } from '@admin/core/models/serializable';
import { Utils } from '@admin/shared/utils';

export class PagingFilter<T extends Serializable<T>>
  implements Serializable<PagingFilter<T>>
{
  fromObject(object: any): PagingFilter<T> {
    throw new Error('Method not implemented.');
  }
  toObject() {
    // let result = {
    //     Filter: this.filter.toObject(),
    //     PagingInfo: { Start: this.pagingInfo && this.pagingInfo.start, Limit: this.pagingInfo && this.pagingInfo.limit }
    // };

    let result = {};

    Object.assign(result, this.filter.toObject(), {
      Start: this.pagingInfo && this.pagingInfo.start,
      Limit: this.pagingInfo && this.pagingInfo.limit,
      SortParameters:
        this.sortParameters &&
        this.sortParameters.map((p) => {
          return { Column: p.column, Order: p.order };
        }),
    });

    return result;
  }

  public filter: T;
  public pagingInfo: { start: number; limit: number };
  public sortParameters: { column: string; order: string }[];

  constructor(actualFilter: T, start?: number, limit?: number) {
    this.filter = actualFilter;
    this.pagingInfo = {
      start: start,
      limit: limit,
    };
  }
}

export interface IPagingFilterBase {
  start?: number;
  limit?: number;
  sortParameters?: SortColumnInfo[];
}

export interface SortColumnInfo {
  column?: string;
  order?: string;
}
